module.exports = __webpack_public_path__ + "img/loading.f38c7e0b.gif";